'use strict';

export default class Notification {
    constructor (type = 'default') {
        this.type = type;
        this.$target = $('#notifications');
        this.$message = $('<div>');

        this.$message.on('click', '.header-message-close', () => {
            this.hide();
        });

        this.setType(this.type);
        this.$message.hide();
    }

    setType (type) {
        this.$message.removeClass('alert-default');
        this.$message.addClass(`alert-${type}`);
    }

    setContent (content) {
        // Add type-dependent class (warning, success, danger, ecc..)
        this.$message.get(0).className = '';
        this.$message.addClass('header-message dismissable');
        const html = `
        <div class="grid-container header-message-content">
            <div class="grid-x">
                <div class="cell">${content}</div>
            </div>
        </div><div class="header-message-close">&times;</div>`;

        this.$message.html(html);
    }

    show (override = true) {
        // if other notifications are still open replace the current message with the new one
        if (override && this.$target.children().length > 0) {
            this.$target.find('.header-message').replaceWith(this.$message);
            this.$message.slideDown();
            window.clearTimeout(this.timer);
            return;
        }
        // if there was no previous notification, or this method was called with
        // override = false, add the notification
        this.addNotification();
    }

    addNotification () {
        this.$target.append(this.$message);
        this.$message.slideDown();
        window.clearTimeout(this.timer);
    }

    hide () {
        this.$message.slideUp(300, () => {
            this.$message.remove();
        });
    }

    timeout (time) {
        this.timer = window.setTimeout(() => {
            this.hide();
        }, time);
    }
}
